import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white px-4">
      <div className="container flex h-24 items-center justify-between mx-auto px-4">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center">
            <div className="relative h-auto w-52">
              <img
                src="/Header-LocalLive_Red_wTag-White.png"
                alt="LocalLive Logo"
              />
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
